import {Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { LivestreamService } from 'src/app/Core/services/livestream.service';
import { MovieService } from 'src/app/Core/services/movie.service';
import { SeriesService } from 'src/app/Core/services/series.service';
import { UtilService } from 'src/app/Core/services/util.service';
import { Constant } from 'src/app/Core/services/data';

@Component({
  selector: 'app-refreshdb-modal',
  templateUrl: './refreshdb-modal.component.html',
  styleUrls: ['./refreshdb-modal.component.css']
})
export class RefreshDbModalComponent implements OnInit {
  playlistItem: any;
  onClose: Subject<string> = new Subject();
  isLoadingdb: boolean = true;

  // NEW:
  mode: 'all' | 'livetv' | 'movies' | 'series' = 'all';

loadingItems = [
  { label: 'Live TV', key: 'livetv', loaded: false, progress: 0 },
  { label: 'Movies', key: 'movies', loaded: false, progress: 0 },
  { label: 'Series', key: 'series', loaded: false, progress: 0 }
];

  overallProgress = 0;
  currentLabel = '';

  constructor(
    public bsRef: BsModalRef,
    private router: Router,
    private livetvService: LivestreamService,
    private moviesService: MovieService,
    private seriesService: SeriesService,
    private utilService: UtilService
  ) {}

  get filteredItems() {
  if (this.mode === 'all') return this.loadingItems;
  return this.loadingItems.filter(item => item.key === this.mode);
}

  async ngOnInit() {
    try {
      const item = this.playlistItem;
      const total = this.mode === 'all' ? 3 : 1;
      let completed = 0;
      if (this.mode === 'all' || this.mode === 'livetv') {
        this.currentLabel = 'Loading Live TV categories...';
        await this.livetvService.loadLivetvdbCategories(true);
        this.currentLabel = 'Loading Live TV streams...';
        await this.livetvService.loadLivetvdb(true);
        this.markLoaded(0, ++completed, total);
      }

      if (this.mode === 'all' || this.mode === 'movies') {
        this.currentLabel = 'Loading Movie categories...';
        await this.moviesService.loadMovieCategories(true);
        this.currentLabel = 'Loading Movies...';
        await this.moviesService.loadMoviesdb(true);
        this.markLoaded(1, ++completed, total);
      }

      if (this.mode === 'all' || this.mode === 'series') {
        this.currentLabel = 'Loading Series categories...';
        await this.seriesService.loadCategoriesdb(true);
        this.currentLabel = 'Loading Series...';
        await this.seriesService.loadSeriesdb(true);
        this.markLoaded(2, ++completed, total);
      }

      this.currentLabel = 'All content loaded!';
      setTimeout(() => {
        this.onClose.next('yes');
        this.bsRef.hide();
      }, 1000);

    } catch (err) {
      console.error('Error loading data:', err);
      this.onClose.next('no');
      this.bsRef.hide();
    } finally {
      this.isLoadingdb = false;
    }
  }

  markLoaded(index: number, completed: number, total: number) {
    this.loadingItems[index].loaded = true;
    this.loadingItems[index].progress = 100;
    this.overallProgress = Math.round((completed / total) * 100);
  }
}
